export default __webpack_public_path__ + "static/media/mkt-place-image1.11abd1e5.png";